var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconReturningProspect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_726",
    "data-name": "Group 726",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_371",
    "data-name": "Rectangle 371",
    width: 30,
    height: 30,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_713",
    "data-name": "Group 713",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12765",
    "data-name": "Path 12765",
    d: "M30,15A15,15,0,1,1,15,0,15,15,0,0,1,30,15",
    fill: "#7c97c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12766",
    "data-name": "Path 12766",
    d: "M24.646,16.065a.772.772,0,0,0-.9.613A8.9,8.9,0,0,1,8.115,20.645l2.143-.117A18.642,18.642,0,0,1,5.5,16.822a18.612,18.612,0,0,1-.639,6L6.6,21.2a10.446,10.446,0,0,0,18.661-4.238.771.771,0,0,0-.613-.9",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12767",
    "data-name": "Path 12767",
    d: "M5.354,13.936a.8.8,0,0,0,.145.014.773.773,0,0,0,.757-.627A8.9,8.9,0,0,1,21.885,9.356l-2.143.117a18.625,18.625,0,0,1,4.76,3.706,18.668,18.668,0,0,1,.639-6L23.4,8.8A10.446,10.446,0,0,0,4.741,13.034a.771.771,0,0,0,.613.9",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReturningProspect);
export default __webpack_public_path__ + "static/media/icon-returning_prospect.2c1148149263c24b1f96d09b127476ac.svg";
export { ForwardRef as ReactComponent };